import CompanyBlocker from '@/app/[lng]/components/BlockerModal/CompanyBlocker'
import ShortListingCard from '@/app/[lng]/components/Cards/ShortListingCard'
import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import { useTranslation } from '@/app/i18n/client'
import { CompanySalesResponse, SalesOffer } from '@/app/types/companyOfferType'
import LimitPagination from '@/components/LimitPagination'
import { Skeleton } from '@/components/ui/skeleton'
import { companyOffersData } from '@/services/companyDetailsService'
import { RootState } from '@/app/globalRedux/store'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const AlertAndOffer: React.FC<{ id: string }> = ({ id }) => {
  const [showContent, setShowContent] = useState<boolean | null>(null)
  const { t } = useTranslation()
  const { access_count, isBeneficiary,accessPer } = useSelector(
    (state: RootState) => state.user
  )
  const [offers, setOffers] = useState<SalesOffer[]>([])
  const [totalCount, setTotalCount] = useState<number>(1)
  const per_page = 6
  const [page, setPage] = useState<number>(1)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const sales_offer: CompanySalesResponse = await companyOffersData(
          id,
          page
        )
        if (sales_offer?.message == 'Access Exhausted') {
          setShowContent(false)
        } else {
          setShowContent(true)

          setOffers(sales_offer.sales_offers)
          setTotalCount(sales_offer.count)
        }
      } catch (error) {
        console.error('Error fetching offers:', error)
      }
    }
    fetchData()
  }, [page])
  if (showContent === null) {
    return <Skeleton className="w-[952px] h-[500px]" />
  }

  return (
    <main className="w-[952px] mobile-width">
      {!showContent && (
        <CompanyBlocker
          access_count={access_count}
          isBeneficiary={isBeneficiary}
          accessPer={accessPer}

        />
      )}
      <div className="flex justify-between border-b border-solid border-gray_btn pb-[17px] items-center">
        <div className="text-[#4a4a4a] text-[16px] font-ns_bold">
          {t('Offers')}
        </div>
      </div>
      <div className="grid grid-wrap grid-cols-3 max-w-max gap-x-5 gap-y-6 mt-[28px] border-b border-solid border-gray_btn pb-[41px]">
        {offers?.map((offer, index) => (
          <CustomErrorBoundary key={index}>
            <ShortListingCard cardData={offer.offer} cardType="Seller" />
          </CustomErrorBoundary>
        ))}
      </div>
      <div>
        {totalCount > 0 ? (
          <LimitPagination
            currentPage={page}
            pageCount={Math.ceil(totalCount / per_page)}
            visiblePages={5}
            onPageChange={setPage}
          />
        ) : (
          ''
        )}
      </div>
      {offers && offers?.length === 0 && (
        <div className="p-16 flex flex-col gap-2 items-center justify-center text-primary-foreground">
          <Image
            loading="lazy"
            width={76}
            height={93}
            src="/assets/Icons/noImage/noOfferIcon.svg"
            alt=""
            className="w-[76px] h-[96px] object-cover border"
          />
          <div className="flex">
            {t('Sales Offers not available at this moment')}
          </div>
        </div>
      )}
    </main>
  )
}

export default AlertAndOffer
